function removeCookieItem(sKey, sPath) {
    if (!sKey || !hasItem(sKey)) {
        return false;
    }
    const domain = getOneLevelDomain();
    document.cookie =
        encodeURIComponent(sKey) +
        '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
        (domain ? '; domain=' + domain : '') +
        (sPath ? '; path=' + sPath : '');
    return true;
}
function getItemFromCookie(sKey) {
    return (
        decodeURIComponent(
            document.cookie.replace(
                new RegExp(
                    "(?:(?:^|.*;)\\s*" +
                    encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") +
                    "\\s*\\=\\s*([^;]*).*$)|^.*$",
                ),
                "$1",
            ),
        ) || null
    );
}
function setItemToCookie(sKey, sValue, vEnd, sPath, doma, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
        return false;
    }
    const sDomain = getOneLevelDomain()
    let sExpires = "; expires=Fri, 31 Dec 9999 23:59:59 GMT";
    if (vEnd) {
        switch (vEnd.constructor) {
            case Number:
                sExpires =
                    vEnd === Infinity
                        ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT"
                        : "; max-age=" + vEnd;
                break;
            case String:
                sExpires = "; expires=" + vEnd;
                break;
            case Date:
                sExpires = "; expires=" + vEnd.toUTCString();
                break;
        }
    }
    document.cookie =
        encodeURIComponent(sKey) +
        "=" +
        encodeURIComponent(sValue) +
        sExpires +
        (sDomain ? "; domain=" + sDomain : "") +
        (sPath ? "; path=" + sPath : "") +
        (bSecure ? "; secure" : "");
    return true;
}
function isIp(url) {
    // 正则表达式来匹配IPv4地址
    const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    // 正则表达式来匹配IPv6地址
    const ipv6Regex = /^([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}$/;

    // 移除URL中的协议头（如http://, https://）
    const cleanUrl = url.replace(/^https?:\/\//, '');

    // 检查是否为IPv4或IPv6地址
    return ipv4Regex.test(cleanUrl) || ipv6Regex.test(cleanUrl);
}
function getOneLevelDomain() {
    const host = window.location.hostname;
    const urlIsIp = isIp(host);
    let domain = host;
    if (!urlIsIp) {
        domain = host.split('.').slice(-2).join('.');
    }
    console.log(domain);
    return `.${domain}`;
}
function hasItem(sKey) {
    return new RegExp(
        "(?:^|;\\s*)" +
        encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") +
        "\\s*\\=",
    ).test(document.cookie);
}

export {
    getItemFromCookie,
    setItemToCookie,
    isIp,
    getOneLevelDomain,
    removeCookieItem,

}